import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Select from 'react-select'
import useScreenSize from "../hooks/useScreenSize";

const StyledSelect = styled(Select)`
    width: ${props => props.small? '120px' : '170px'};
    font-size:  ${props => props.small? '12px' : '14px'};
`

const DropdownMenuWrapper = styled.div`
    z-index: 20;
`

const DropdownMenu = (props) => {

    const options = [
        {
            value: 'mamma',
            label: 'Mammaperm'
        },{
            value: 'pappa',
            label: 'Pappaperm'
        },{
            value: 'felles',
            label: 'Fellesperm'
        },{
            value: 'mammaFerie',
            label: 'Mor Ferie'
        },{
            value: 'pappaFerie',
            label: 'Far Ferie'
        },{
            value: 'beggeFerie',
            label: 'Begge Ferie'
        },{
            value: 'mammaUlonnetPerm',
            label: 'Mor Ulønnet Perm'
        },{
            value: 'pappaUlonnetPerm',
            label: 'Far Ulønnet Perm'
        },
    ];

    const [selected, setSelected] = useState(options[5]);

    useEffect(() => {
        if (props.select){
            var defaultSelect = options.find(option => option.value === props.select)
            setSelected(defaultSelect);
        }
    }, []);

    function onSelect(item) {
        props.setPermType(item);
        setSelected(item);
    }

    return (
        <DropdownMenuWrapper style={props.style}>
            <StyledSelect
                options={options}
                value={selected}
                placeholder={"Type permisjon"}
                onChange={onSelect}
                small={props.small}
            />
        </DropdownMenuWrapper>
    )
}

export default DropdownMenu;
